import styled from "styled-components";

import * as Types from "Types";

import AtomChannelIcon from "Components/Atoms/ChannelIcon";
import AtomDescription2 from "Components/Atoms/Description2";

const Wrap = styled.a<any>`
   text-align: center;
   cursor: pointer;
   ${({ css }) => css}
`;

const Text = styled(AtomDescription2)<Types.Default>`
   ${({ css }) => css}
`;

const ChannelIcon = styled(AtomChannelIcon)<Types.Atoms.ChannelIcon>`
   width: 122px;
`;

function Content1(props: Types.Molecules.Channel) {
   return (
      <Wrap {...props} target="_blank">
         {props.children}
      </Wrap>
   );
}

Content1.Icon = function (props: Types.Atoms.ChannelIcon) {
   return <ChannelIcon {...props}></ChannelIcon>;
};

Content1.Text = function (props: Types.Default) {
   return <Text {...props}></Text>;
};

export default Content1;
